import { Component, ViewChild, ElementRef } from '@angular/core';
import { NavController, NavParams, ModalController } from 'ionic-angular';
import { GN } from '../../gn';
import { DIC } from '../dic';
import * as moment from 'moment';


/**
 * Generated class for the FueldropdetailsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-fueldropdetails',
  templateUrl: 'fueldropdetails.html',
})
export class FueldropdetailsPage {
  loadingData: boolean = true
  fulldt: any;
  vehicleid: any;
  ReportData = [];
  pochFuel: any;
  dtfueldown: any;

  constructor(public navCtrl: NavController, public navParams: NavParams, public gn: GN, public dic: DIC, public modalCtrl: ModalController) {
    this.fulldt = this.navParams.get('fulldt');
    this.vehicleid = this.navParams.get('vehicleid');
    this.pochFuel = this.navParams.get('pochFuel');
    this.dtfueldown = this.navParams.get('dtfueldown');
    this.loadDetails();
  }

  nnull(_v, _dv) {
    if (_v === null) {
      return _dv;
    } else {
      return _v;
    }
  }

  loadDetails() {
    this.loadingData = true;
    var _that = this;
    this.gn._Post('/api/gn/reports/loadFuelDropDetails', { vid: this.gn.crypt(this.vehicleid), dt: this.gn.crypt(this.fulldt) }, function (_data) {
      _that.ReportData = _data.data
      //var _fuelparams = _data.fuelparams[0].fueldown.split("|")
      var dtTmpStart1 = _that.dtfueldown;
      var dtTmp = _that.fulldt

      //console.log(_fuelparams[0], _fuelparams[1])
      //console.log(_that.pochFuel, _that.dtfueldown)

      var cnt = 1;
      var start = 0;
      var end = 0;
      var greenTmp = 0;

      for (var i = 0; i < _that.ReportData.length; i++) {
        var color = [{ backgroundcolor: '#ffffff', color: '#000000', fontweight: 'normal', opacity: 1 }];
        var color1 = [{ backgroundcolor: '#ffffff', color: '#000000', fontweight: 'normal' }];

        if (start == 0 && moment(dtTmpStart1).format('HH:mm:ss') == moment(_that.ReportData[i].datetime).format('HH:mm:ss') && parseInt(_that.pochFuel) == parseInt(_that.ReportData[i].fuel)) {
          color = [{ backgroundcolor: '#EDFCEE', color: '#77992e', fontweight: 'bold', opacity: 1 }];
          color1 = [{ backgroundcolor: '#77992e', color: '#ffffff', fontweight: 'bold' }];
          start = 1;
          greenTmp = cnt;
        }

        if ((start == 0 && end == 0) || (start == 1 && end == 1)) {
          color = [{ backgroundcolor: '#ffffff', color: '#000000', fontweight: 'normal', opacity: 0.3 }];
        }

        if (end == 0 && moment(dtTmp).format('HH:mm:ss') == moment(_that.ReportData[i].datetime).format('HH:mm:ss')) {
          color = [{ backgroundcolor: '#FCEDED', color: '#ad3b37', fontweight: 'bold', opacity: 1 }];
          color1 = [{ backgroundcolor: '#ad3b37', color: '#ffffff', fontweight: 'bold' }];
          end = 1;
        }

        _that.ReportData[i].time = moment(_that.ReportData[i].datetime).format('HH:mm:ss')
        _that.ReportData[i].ignition = _that.dic.l[_that.ReportData[i].ign + "motor"]
        _that.ReportData[i].speed = parseInt(_that.ReportData[i].speed)
        _that.ReportData[i].fuel = parseInt(_that.ReportData[i].fuel)
        _that.ReportData[i].poinames = _that.nnull(_that.ReportData[i].poinames, '')
        _that.ReportData[i].zonenames = _that.nnull(_that.ReportData[i].zonenames, '')
        _that.ReportData[i].polynames = _that.nnull(_that.ReportData[i].polynames, '')
        _that.ReportData[i].color = color;
        _that.ReportData[i].color1 = color1;


        if (i == _that.ReportData.length - 1) {
          _that.loadingData = false;
          setTimeout(() => {
            var el = document.getElementById("greenrow");
            var elclass = el.classList;
            var elidx = -1;
            for (var c = 0; c < elclass.length; c++) {
              if (elclass[c].indexOf('fuelcol') != -1) {
                elidx = parseInt(elclass[c].split('fuelcol')[1] + '');
              }
            }
            var els = document.getElementsByClassName("lastcol");
            els[elidx - 2].scrollIntoView();

            // var els = document.getElementsByClassName("lastcol");
            // //els[100].scrollIntoView();
            // for (var x = 0; x < els.length; x++) {
            //   var el = <HTMLElement>els[x]
            //   if (el.style.backgroundColor == 'rgb(119, 153, 46)') {
            //     var el1 = <HTMLElement>els[x - 2]
            //     el1.scrollIntoView();
            //   }
            // }
          }, 100);
        }
      }
    })
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad FueldropdetailsPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/fueldropdetails/fueldropdetails.ts